import BaseModule from './BaseModule'

/**
 * Simple actions on element common events
 */

const actionTable = {
    toggleClass: act => $(act.target).toggleClass(act.class)
}

class Action extends BaseModule {
    constructor(o) {
        super(o);
        this.events = this.$el.data('events');
        this.enable();
    }

    enable () {
        super.enable();
        for (let event in this.events) this.$el.on(event, () => this.act(event));
    }

    act (event) {
        let e = this.events[event];
        for (let action in e) actionTable[action](e[action]);
    }

    disable () {
        super.disable();
        this.$el.off(Object.keys(this.actions).join(' '));
    }
}

export default Action
